<template>
  <svg class="_component-icon-svg" @click="$emit('click')" width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 3.76066C8.37209 12.5844 11.1628 13.7229 20 16V0.0603924C19.6899 -0.603758 16 4.44378 0 3.76066Z" :style="componentStyle" />
  </svg>
</template>

<script>
/**
 * @module Dialogue 对话框小角标
 */
export default {
  name: 'Dialogue',
  /**
   * @prop {String} color 颜色
   */
  props: {
    color: {
      type: String,
      default: '#FDF8E5'
    }
  },
  /**
   * @member {Object} componentStyle 组件style
   */
  computed: {
    componentStyle() {
      return {
        fill: this.color
      };
    },
    strokeColor() {
      return this.color === 'none' ? '#494A4D' : this.color;
    }
  }
};
</script>
